import styled from "styled-components";

const Title_FontSize_Header = "14px";
const Title_FontSize_Page = "18px";
const Title_LineHeight_Header = "32px";
const Title_LineHeight_Page = "56px";
const Content_Padding_Header = "10px 16px";
const Content_Padding_Page = "20px";
const Content_Title_Header = "12px";
const Content_Title_Page = "14px";
const Radio_Height_Header = "38px";
const Radio_Height_Page = "48px";
const Content_MarginBottom_Header = "10px";
const Content_MarginBottom_Page = "0";

const CustomiseWrapper = styled.div<{ $type: number }>`
  padding: ${(props) => (props.$type ? Content_Padding_Page : Content_Padding_Header)};
  color: var(--sys-Text-Primary);

  div {
    margin-bottom: ${(props) => (props.$type ? Content_MarginBottom_Page : Content_MarginBottom_Header)};
  }

  img {
    width: 28px;
    height: 14px;
  }

  .loadingContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
  }

  .title {
    font-size: ${(props) => (props.$type ? Title_FontSize_Page : Title_FontSize_Header)};
    font-weight: bold;
    height: ${(props) => (props.$type ? Title_LineHeight_Page : Title_LineHeight_Header)};
  }

  .title-margin {
    margin-left: 10px;
  }

  .content-title {
    font-size: ${(props) => (props.$type ? Content_Title_Page : Content_Title_Header)};

    label {
      height: ${(props) => (props.$type ? Radio_Height_Page : Radio_Height_Header)};

      span {
        font-size: ${(props) => (props.$type ? Content_Title_Page : Content_Title_Header)};
      }
    }
  }

  .line {
    border-top: 1px solid #f0f1f2;
    margin: 30px 0;
  }

  .change-btn-box {
    cursor: pointer;

    .change-btn {
      display: inline-block;
      line-height: 32px;
      font-size: 14px;
      color: #1869F5
    }
  }

  .countryInfoContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .countryAlert {
      width: 50%;
      padding-left: 24px;
      box-sizing: border-box;
    }
  }

  .language-grid-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
    
    .language-column {
      flex: 1;
      min-width: 200px;
      max-width: 300px;
    }
  }

  .MuiInputBase-root {
    margin-top: 10px;

    #select {
      height: 34px;
      padding: 0 0 0 10px;
      width: 200px;
      display: flex;
      align-items: center;
      margin: 0;
    }
  }

  #footer {
    margin-top: 20px;

    .btn {
      padding: 10px 16px;
      margin-right: 10px;
      border-radius: 4px;
    }

    .confirm {
      background-color: var(--sys-color-Primary700);
      color: #fff;
    }

    .cancel {
      border: 1px solid #e0e1e5;
      border-radius: 4px;
    }
  }
`;

export default CustomiseWrapper;
